<template>
  <BaseDraggableModal
      ref="modal_vtss_invoices"
      :name="'modal_vtss_invoices'"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card :disabled="loading" :loading="loading">
      <BaseModal>
        <v-card-title class="draggable_selector" slot="header">
          VTSS Invoices
        </v-card-title>
        <v-card-text slot="content">

<!--          <div>
            <p>Status: {{ status }}</p>
            <p>Message: {{ message }}</p>
            <p>Invoices: {{ invoices.length }}</p>
            <p>Warnings: {{ warnings.length }}</p>
          </div>-->

          <div v-if="status === 'changed'">
            <v-alert type="info">
              {{ message }}
            </v-alert>
          </div>

          <div v-if="status === 'failure'">
            <v-alert type="error">
              {{ message }}
            </v-alert>
          </div>

          <div v-if="warnings.length > 0">
            <v-alert type="warning">
              <div v-for="(warning, index) in warnings" :key="index">

                <div v-if="language === 'en'">
                  <p v-if="warning.type === 'no_companies'">
                    Candidate
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    has no company set.
                  </p>

                  <p v-else-if="warning.type === 'multiple_companies'">
                    Candidate
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    has multiple companies set.
                  </p>

                  <p v-else-if="warning.type === 'no_session_price'">
                    Session
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.session_name">{{ warning.session_name }}</strong>
                      <strong v-else>{{ warning.session_id }}</strong>
                    </a>
                    has no price set.
                  </p>

                  <p v-else-if="warning.type === 'no_course_price'">
                    Scheme
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.scheme_name">{{ warning.scheme_name }}</strong>
                      <strong v-else>{{ warning.scheme_id }}</strong>
                    </a>
                    has no course price set.
                  </p>

                  <p v-else-if="warning.type === 'no_certificate_price'">
                    Scheme
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.scheme_name">{{ warning.scheme_name }}</strong>
                      <strong v-else>{{ warning.scheme_id }}</strong>
                    </a>
                    has no certificate price set.
                  </p>

                  <p v-else-if="warning.type === 'no_candidate_data'">
                    The <strong>{{ warning.data }}</strong> is missing for the candidate
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else-if="warning.type === 'no_exam_data'">
                    The <strong>{{ warning.data }}</strong> is missing for the exam
                    <a :href="'/exams/' + warning.exam_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.exam_name">{{ warning.exam_name }}</strong>
                      <strong v-else>{{ warning.exam_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else-if="warning.type === 'no_company_data'">
                    The <strong>{{ warning.data }}</strong> is missing for the company
                    <a :href="'/companies/' + warning.company_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.company_name">{{ warning.company_name }}</strong>
                      <strong v-else>{{ warning.company_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else>
                    Required information is missing from the invoices.
                  </p>
                </div>

                <div v-if="language === 'nl'">
                  <p v-if="warning.type === 'no_companies'">
                    Kandidaat
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    heeft geen bedrijf ingesteld.
                  </p>

                  <p v-else-if="warning.type === 'multiple_companies'">
                    Kandidaat
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    heeft meerdere bedrijven ingesteld.
                  </p>

                  <p v-else-if="warning.type === 'no_session_price'">
                    Sessie
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.session_name">{{ warning.session_name }}</strong>
                      <strong v-else>{{ warning.session_id }}</strong>
                    </a>
                    heeft geen prijs ingesteld.
                  </p>

                  <p v-else-if="warning.type === 'no_course_price'">
                    Schema
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.scheme_name">{{ warning.scheme_name }}</strong>
                      <strong v-else>{{ warning.scheme_id }}</strong>
                    </a>
                    heeft geen cursusprijs ingesteld.
                  </p>

                  <p v-else-if="warning.type === 'no_certificate_price'">
                    Schema
                    <a :href="'/schemes/' + warning.scheme_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.scheme_name">{{ warning.scheme_name }}</strong>
                      <strong v-else>{{ warning.scheme_id }}</strong>
                    </a>
                    heeft geen certificaatprijs ingesteld.
                  </p>

                  <p v-else-if="warning.type === 'no_candidate_data'">
                    De <strong>{{ warning.data }}</strong> ontbreekt voor kandidaat
                    <a :href="'/candidates/' + warning.candidate_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.candidate_name">{{ warning.candidate_name }}</strong>
                      <strong v-else>{{warning.candidate_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else-if="warning.type === 'no_exam_data'">
                    De <strong>{{ warning.data }}</strong> ontbreekt voor het examen
                    <a :href="'/exams/' + warning.exam_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.exam_name">{{ warning.exam_name }}</strong>
                      <strong v-else>{{ warning.exam_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else-if="warning.type === 'no_company_data'">
                    Het <strong>{{ warning.data }}</strong> ontbreekt voor het bedrijf
                    <a :href="'/companies/' + warning.company_id" target="_blank" class="white--text text-decoration-underline">
                      <strong v-if="warning.company_name">{{ warning.company_name }}</strong>
                      <strong v-else>{{ warning.company_id }}</strong>
                    </a>
                    .
                  </p>

                  <p v-else>
                    Vereiste informatie ontbreekt op de facturen.
                  </p>
                </div>

              </div>
            </v-alert>
          </div>

          <div>
            <v-expansion-panels multiple>
              <v-expansion-panel v-for="(invoice, index) in invoices" :key="index">
                <v-expansion-panel-header>Invoice {{ index + 1 }} ({{ invoice.naam }})</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p class="text-subtitle-1 font-weight-bold">Organisatie</p>
                  <v-container class="py-2 mt-4">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Relatie ID</v-col>
                      <v-col cols="4">{{ invoice.relatieID }}</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Naam</v-col>
                      <v-col cols="4" v-if="invoice.naam">{{ invoice.naam }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Telefoonnummer</v-col>
                      <v-col cols="4" v-if="invoice.telefoonnummer">{{ invoice.telefoonnummer }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Email</v-col>
                      <v-col cols="4" v-if="invoice.email">{{ invoice.email }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>

                  <v-divider class="my-4"></v-divider>

                  <p class="text-subtitle-1 font-weight-bold">Vestigingsadres</p>
                  <v-container class="py-2 mt-4">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Straat</v-col>
                      <v-col cols="4" v-if="invoice.vestigingsadres.straat">{{ invoice.vestigingsadres.straat }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Huisnummer</v-col>
                      <v-col cols="4" v-if="invoice.vestigingsadres.huisnummer">{{ invoice.vestigingsadres.huisnummer }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Postcode</v-col>
                      <v-col cols="4" v-if="invoice.vestigingsadres.postcode">{{ invoice.vestigingsadres.postcode }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Plaats</v-col>
                      <v-col cols="4" v-if="invoice.vestigingsadres.plaats">{{ invoice.vestigingsadres.plaats }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>

                  <v-divider class="my-4"></v-divider>

                  <p class="text-subtitle-1 font-weight-bold">Factuuradres</p>
                  <v-container class="py-2 mt-4">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Naam</v-col>
                      <v-col cols="4" v-if="invoice.factuuradres.naam">{{ invoice.factuuradres.naam }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Straat</v-col>
                      <v-col cols="4" v-if="invoice.factuuradres.straat">{{ invoice.factuuradres.straat }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Huisnummer</v-col>
                      <v-col cols="4" v-if="invoice.factuuradres.huisnummer">{{ invoice.factuuradres.huisnummer }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Postcode</v-col>
                      <v-col cols="4" v-if="invoice.factuuradres.postcode">{{ invoice.factuuradres.postcode }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>
                  <v-container class="py-2">
                    <v-row no-gutters>
                      <v-col cols="2" class="font-weight-medium">Plaats</v-col>
                      <v-col cols="4" v-if="invoice.factuuradres.plaats">{{ invoice.factuuradres.plaats }}</v-col>
                      <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                    </v-row>
                  </v-container>

                  <v-divider class="my-4"></v-divider>

                  <p class="text-subtitle-1 font-weight-bold">Opdrachten</p>
                  <div v-for="(opdrachten, opdrachten_index) in invoice.opdrachten" :key="opdrachten_index">

                    <v-container class="py-2 mt-4">
                      <v-row no-gutters>
                        <v-col cols="2" class="font-weight-medium">Order ID</v-col>
                        <v-col cols="4" v-if="opdrachten.orderID">{{ opdrachten.orderID }}</v-col>
                        <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                      </v-row>
                    </v-container>
                    <v-container class="py-2">
                      <v-row no-gutters>
                        <v-col cols="2" class="font-weight-medium">Eigenaar</v-col>
                        <v-col cols="4" v-if="opdrachten.eigenaar">{{ opdrachten.eigenaar }}</v-col>
                        <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                      </v-row>
                    </v-container>
                    <v-container class="py-2">
                      <v-row no-gutters>
                        <v-col cols="2" class="font-weight-medium">Project</v-col>
                        <v-col cols="4" v-if="opdrachten.project">{{ opdrachten.project }}</v-col>
                        <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                      </v-row>
                    </v-container>

                    <v-divider class="my-4"></v-divider>

                    <p class="text-subtitle-1 font-weight-bold">Examens</p>
                    <div v-for="(examens, examens_index) in opdrachten.examens" :key="examens_index">

                      <v-container class="py-2 mt-4">
                        <v-row no-gutters>
                          <v-col cols="2" class="font-weight-medium">Examen ID</v-col>
                          <v-col cols="4" v-if="examens.examenID">{{ examens.examenID }}</v-col>
                          <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                        </v-row>
                      </v-container>
                      <v-container class="py-2">
                        <v-row no-gutters>
                          <v-col cols="2" class="font-weight-medium">Naam</v-col>
                          <v-col cols="4" v-if="examens.naam">{{ examens.naam }}</v-col>
                          <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                        </v-row>
                      </v-container>
                      <v-container class="py-2">
                        <v-row no-gutters>
                          <v-col cols="2" class="font-weight-medium">Datum</v-col>
                          <v-col cols="4" v-if="examens.datum">{{ examens.datum }}</v-col>
                          <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                        </v-row>
                      </v-container>
                      <v-container class="py-2">
                        <v-row no-gutters>
                          <v-col cols="2" class="font-weight-medium">Locatie</v-col>
                          <v-col cols="4" v-if="examens.locatie">{{ examens.locatie }}</v-col>
                          <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                        </v-row>
                      </v-container>

                      <v-divider class="my-4"></v-divider>

                      <p class="text-subtitle-1 font-weight-bold">Kandidaten</p>
                      <div v-for="(kandidaten, kandidaten_index) in examens.kandidaten" :key="kandidaten_index">

                        <v-container class="py-2 mt-4">
                          <v-row no-gutters>
                            <v-col cols="2" class="font-weight-medium">Kandidaat ID</v-col>
                            <v-col cols="4" v-if="kandidaten.kandidaatID">{{ kandidaten.kandidaatID }}</v-col>
                            <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                          </v-row>
                        </v-container>
                        <v-container class="py-2">
                          <v-row no-gutters>
                            <v-col cols="2" class="font-weight-medium">Naam</v-col>
                            <v-col cols="4" v-if="kandidaten.naam">{{ kandidaten.naam }}</v-col>
                            <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                          </v-row>
                        </v-container>
                        <v-container class="py-2">
                          <v-row no-gutters>
                            <v-col cols="2" class="font-weight-medium">Prijs</v-col>
                            <v-col cols="4" v-if="kandidaten.prijs">{{ kandidaten.prijs }}</v-col>
                            <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                          </v-row>
                        </v-container>
                        <v-container class="py-2">
                          <v-row no-gutters>
                            <v-col cols="2" class="font-weight-medium">Bedrag</v-col>
                            <v-col cols="4" v-if="kandidaten.bedrag">{{ kandidaten.bedrag }}</v-col>
                            <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                          </v-row>
                        </v-container>
                        <v-container class="py-2">
                          <v-row no-gutters>
                            <v-col cols="2" class="font-weight-medium">Kostenplaats</v-col>
                            <v-col cols="4" v-if="kandidaten.kostenplaats">{{ kandidaten.kostenplaats }}</v-col>
                            <v-col cols="4" class="font-weight-bold" v-else>Niet ingesteld</v-col>
                          </v-row>
                        </v-container>

                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

        </v-card-text>
        <div slot="footer">
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="isDisabled" color="primary" text @click="send">
              Send
            </v-btn>
          </v-card-actions>
        </div>
      </BaseModal>
    </v-card>
  </BaseDraggableModal>
</template>

<script>
import BaseModal from "../../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../../components/commonComponents/BaseDraggableModal";

export default {
  components: {
    BaseModal,
    BaseDraggableModal,
  },
  //props: [],
  data() {
    return {
      loading: false,
      exam_id: null,
      invoices: [],
      warnings: [],
      status: null,
      message: '',
    };
  },
  methods: {
    init() {
      this.loading = false;
      this.exam_id = null;
      this.invoices = [];
      this.warnings = [];
      this.status = null;
      this.message = '';
    },
    load(id) {
      //console.log(id);
      this.init();
      this.exam_id = id;
      this.$refs.modal_vtss_invoices.open();
      this.loading = true;
      this.$http
        .post(this.$store.getters.appUrl + "v2/vtss/invoices/generate", { "exam_id": this.exam_id })
        .then((response) => {
          this.status = response.data.status;
          if(this.status === "success") {
            this.invoices = response.data.invoices;
            this.warnings = response.data.warnings;
          } else if(this.status === "failure") {
            if(response.data.warnings) {
              this.warnings = response.data.warnings;
            }

            if(this.language === 'nl') {
              if(response.data.message === 'Unable to generate invoices.') {
                this.message = 'Kan geen facturen genereren.';
              } else if (response.data.message === 'No invoices has been generated.') {
                this.message = 'Er zijn geen facturen gegenereerd.';
              } else {
                this.message = response.data.message;
              }
            } else {
              this.message = response.data.message;
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          this.$toasted.error(error);
          this.loading = false;
        });
    },
    send() {
      if(!this.loading) {
        this.loading = true;
        this.$http
          .post(this.$store.getters.appUrl + "v2/vtss/invoices/create", {
            "exam_id": this.exam_id,
            "invoices": this.invoices,
          }).then((response) => {
            this.status = response.data.status;
            if(this.status === "success") {
              this.$refs.modal_vtss_invoices.close();
              this.$toasted.success("Invoices sent.");
              this.$emit("refresh");
            } else if(this.status === "failure") {
              this.message = response.data.message;
              this.$refs.modal_vtss_invoices.close();
              this.$toasted.error(this.message);
            } else if(this.status === "changed") {
              this.invoices = response.data.invoices;
              this.warnings = response.data.warnings;
              this.message = response.data.message;
            }

            this.loading = false;
          })
          .catch((error) => {
            this.$toasted.error(error);
            this.loading = false;
          });
      }
    },
  },
  computed: {
    isDisabled() {
      return !(
        !this.loading
        && this.status === "success"
        && this.invoices.length > 0
        && this.warnings.length === 0
      );
    },
    language() {
      return this.$store.getters.getLanguage;
    },
  },
};
</script>